module.exports = __webpack_public_path__ + "img/syukyaku-syukyaku-001sp.89cdb508.jpg";